import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import React from 'react';

const DialogPersonalizeProgram = ({ t, open, hasPersonalizedProgram, courseName, onCancel, onSuccess }) => {
  return (
    <div>
      <Dialog
        isOpen={open}
        ariaLabel={t('new-course:Personalize')}
        size="l"
        className="dialog-personalize-program"
        onClose={onCancel}
        onCancel={onCancel}
        onSuccess={onSuccess}
        buttonTextSuccess={hasPersonalizedProgram ? t('course:Use my version') : t('course:Create my version')}
      >
        <div className="personalize-program__wrapper">
          <div className="personalize-program__head">
            <Icon name="pencil" color="primary" size="xl" />
            <div className="personalize-program__head-title">{t('new-course:Personalize')}</div>
          </div>
          {hasPersonalizedProgram ? (
            <div className="personalize-program__content">
              <div className="personalize-program__subhead">
                <TextHtml text={t('course:Use personalized version of x', { name: courseName })} />
              </div>
            </div>
          ) : (
            <div className="personalize-program__content">
              <div className="personalize-program__subhead">{t('course:With this action you create your own version of the program')}</div>
              <div className="personalize-program__entry">
                <div className="personalize-program__entry-icon">
                  <Icon name="check" color="primary" size="xl" />
                </div>
                <div className="personalize-program__entry-text">{t('course:Create new units, lessons and exercises')}</div>
              </div>
              <div className="personalize-program__entry">
                <div className="personalize-program__entry-icon">
                  <Icon name="check" color="primary" size="xl" />
                </div>
                <div className="personalize-program__entry-text">{t('course:Personalize the learning experience in an agile and flexible way')}</div>
              </div>
              <div className="personalize-program__entry">
                <div className="personalize-program__entry-icon">
                  <Icon name="check" color="primary" size="xl" />
                </div>
                <div className="personalize-program__entry-text">{t('course:The original version will always be available in the library')}</div>
              </div>
              <div className="personalize-program__entry">
                <div className="personalize-program__entry-text">{t('course:Do you want to create your own version?')}</div>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};

DialogPersonalizeProgram.defaultProps = {
  onCancel: function () {},
  onSuccess: function () {},
  open: false,
};

export default DialogPersonalizeProgram;
